<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
// Template SFC — PRESENTATION ONLY (DEV-1135 template purity contract).
defineProps<{
  question: {
    id: string;
    title: string;
    answers: [string, string, string?, string?, boolean?][];
  };
  selected: string[];
}>();
</script>

<template>
  <div class="tpl-trf__question">
    <h2 v-if="question.title" class="tpl-trf__question-title">{{ question.title }}</h2>
    <div class="tpl-trf__answers">
      <button
        v-for="answer in question.answers"
        :key="answer[0]"
        type="button"
        class="tpl-trf__answer"
        :class="{ 'tpl-trf__answer--selected': selected.includes(answer[0]) }"
        @click="$emit('answer', answer)"
      >
        {{ String(answer[1]) }}
      </button>
    </div>
  </div>
</template>
